<template>
  <v-app>
    <AxiosPreloaderAndResponse />
    <ModalTransferChatUser />
    <router-view></router-view>
  </v-app>
</template>

<script>
import AxiosPreloaderAndResponse from './components/AxiosPreloaderAndResponse.vue';
import { mapGetters } from 'vuex';
import HELPERS from '@/modules/OperatorPanel/helpers';
import i18n from "@/lang/i18n";
import ModalTransferChatUser from "@/modules/OperatorPanel/views/chats/components/ModalTransferChatUser.vue";
import Vue from "vue";

export default {
  name: 'MainApp',

  sockets: {
    notification(data) {
      const options = {
        position: 'top-center',
        timeout: 4000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        closeButton: 'button',
        icon: true,
      };

      let title = data?.title || ''
      let message = data.message;

      if (data.message_alias) {
        switch (data.message_alias) {
          case 'link_exported_file':
            title = this.$t('notification.link_exported_file');
            break;

          case 'failed_store_file_mio':
            title = this.$t('notification.failed_store_file_mio');
            break;

          case 'broadcast_success':
            message = this.$t('notification.broadcast_success');
            break;

          case 'broadcast_error':
            message = this.$t('notification.broadcast_error');
            break;

          case 'email_token_set':
            message = 'email_token_set'
            this.reloadPageIfUserOnBotSettings()

            break;
        }
      }

      // this.$toast(message, { ...options, ...data.options });
      this.$store.dispatch('updateAjaxDialog', [
        true,
        false,
        title,
        message,
        false,
        { ...options, ...data.options },
        data?.message_type || null,
      ]);
    },

    new_message(data) {
      this.messagesListener(data);
    },

    chat_room_created(data) {
      this.rulesPlayNotification(data, 'chat_room_created')
    },

    chat_room_update(data) {
      this.rulesPlayNotification(data, 'chat_room_update')
    },

    participants_connected(data){
      //notification if added me
      if(this.opUserInfo?.id === data.data?.user_id) {
        this.playNotification(
          this.$t('modules.op.texts.participant_added'),
          null,
          'participants_connected'
        );
      }
    },

    connect_error(err) {
      HELPERS.handleError([err, i18n.t("common.error"), i18n.t("common.error_network")]);
    },

    connect() {
      this.$socket.client.emit('login', this.opUserInfo?.id);
      this.$socket.client.emit('joinRoom', 'engine');
    },

    //chat transfers
    transfers(data) {
      this.setChatRoomTransfers(data)
    },
    send_transfer_chat(data) {
      this.sendTransferChat(data)
    },
    transfer_cancelled(data) {
      this.transferCanceled(data)
    },
    transfer_accepted(data) {
      this.transferAccepted(data)
    },
    transfer_cancelled_by_timeout(data){
      this.transferCancelledByTimeout(data)
    },

    //operator status
    status_change(data){
      this.$consoleLogHandler({text: 'STC', data: data})
      this.statusChange(data)
    },

    //copilot events
    messageFromCopilot(data) {
      this.pushMessageFromCopilot(data)
      console.log(data, 'messageFromCopilot')
    },
  },

  beforeCreate() {

    //set language for html attr lang from cookie
    let user_lang = this.$getCookie('user_lang')
    if(user_lang){
      document.documentElement.setAttribute("lang", user_lang);
    }
  },

  created() {
    if(!Vue.$cookies.get("token_c") && this.$route?.name !== 'Login')
      this.$router.push({ name: 'Login' });

    window.onbeforeunload = () => {
      if (this.opUserInfo && this.bot_settings?.active_id) {
        if(typeof this.opUserInfo?.settings_json !== 'object' || this.opUserInfo?.settings_json?.reset_status === true) {
          this.$store.dispatch('opSetUserStatus', {
            status_id: 2,
            bot_id: this.bot_settings.active_id,
          });
        }
      }
    };

    //replaced to Layout
    // this.$store.dispatch('OpAxiosGetMyInfo');

    /* for DEBUGGING State */
    // this.$store.subscribeAction((action, state) => {
    //   console.log('ACTIONNN SUBSCRIBER', action.type,)
    // })
    // this.$store.subscribe((mutation, state) => {
    //   console.log('MUTATION SUBSCRIBER', mutation)
    // });
  },

  mounted() {
    // Version check: detect new deployment and auto-reload (runs after delay + on tab focus, throttled)
    let lastVersionCheck = 0;
    const VERSION_CHECK_THROTTLE_MS = 5 * 60 * 1000;
    const runVersionCheck = () => {
      const now = Date.now();
      if (now - lastVersionCheck < VERSION_CHECK_THROTTLE_MS) return;
      lastVersionCheck = now;
      console.log('[Kwizbot VersionCheck] Running version check...');
      this.$checkForNewVersion();
    };
    setTimeout(runVersionCheck, 30000);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') runVersionCheck();
    });

    // Audio instance
    const audio = new Audio('/500-ms-silence.mp3');
    let $this = this

    // Adding an event listener to the entire document
    document.body.addEventListener('click', function playAudioOnce() {
      audio.play()
        .then(() => {
          $this.$consoleLogHandler('Audio started playing successfully! on MOUNTED')
          $this.$store.dispatch('OpSetNotificationsEnabled', true)
          // Remove event listener after the audio has started
          document.body.removeEventListener('click', playAudioOnce);
        })
        .catch(err => {
          this.$consoleLogHandler({ text: 'Audio started playing Error! on MOUNTED', data: err })
          $this.$store.dispatch('OpSetNotificationsEnabled', false)
        });
    });


    this.$root.$on('initCodeWidget', () => {
      this.initCodeChatWidget()
    });
  },

  computed: {
    ...mapGetters([
      'opChatRooms',
      'opActiveChatRoom',
      'opActiveChatRoomFromState',
      'opUserInfo',
      'bot_settings',
      'opSubjectList',
      'user',
      'get_instance_settings',
    ]),
  },

  watch: {
    //TODO: strange code
    opUserInfo: function (user) {
      if (user?.id) {
        this.$socket.client.emit('login', user.id);
        this.$socket.client.emit('joinRoom', 'engine');
      }
    },

    /* for DEBUGGING Route */
    // '$route' (to, from) {
    //   console.log('Route changed from ' + from.path + ' to ' + to.path);
    // },
  },

  methods: {
    async messagesListener(event) {
      const message = event.data;
      const roomId = (typeof event.data.chat_room_id === 'string')
        ? event.data.chat_room_id = Number(event.data.chat_room_id)
        : event.data.chat_room_id


      //message from Copilot
      //TODO: here

      if (message?.system || message?.isUser) {

        //save msg in Active Dialog if isUser
        if (this.opActiveChatRoom?.id === roomId) {
          await this.$store.dispatch('opAddMessageToActiveChatRooms', event);
        } else {
          await this.$store.dispatch('opAddMessageToChatRoom', event);
        }
        //save msg in Active Dialog if isUser

        return;
      }

      const authorId = message?.participant_id;
      const text = message?.message_text;

      const isEqualAuthorId = (participant) => participant.id === authorId;

      const isExistInChatRooms = (room) => room.id === roomId;

      const getChatRoom = (room) => {
        const participants = room.participants || [];
        return participants.some(isEqualAuthorId);
      };

      const getParticipant = () => {
        const chatRoom = this.opChatRooms.find(getChatRoom);

        if (chatRoom === undefined) {
          return null;
        }

        const participant = chatRoom.participants.find(isEqualAuthorId);

        return participant;
      };

      const authorObj = getParticipant(authorId);

      //return if room not exist in Rooms
      if (!this.opChatRooms.find(isExistInChatRooms)) return

      if (authorObj?.user_id === this.opUserInfo.id) {
        return;
      }

      const author = authorObj?.client || authorObj?.user;

      const authorName = HELPERS.formatClientName(author);

      //check if user exist in participants of the chat
      if(this.opChatRooms.find(isExistInChatRooms)?.participants?.length){
        const isMeInChat = this.opChatRooms.find(isExistInChatRooms)?.participants
          .some(({user_id}) => user_id && user_id === this.opUserInfo.id)

        if (isMeInChat) {
          await this.playNotification(authorName, text, 'new_message');
        }
      }

      const urlParams = new URLSearchParams(window.location.search);

      if (
        (!this.opActiveChatRoom?.id && !urlParams.get('chat_room_id'))
        || (+urlParams.get('chat_room_id') !== roomId)
      ) {
        this.$store.dispatch('opSetChatNotification', event);
      } else if (this.opActiveChatRoom?.id === roomId) {
        this.$store.dispatch('opAddMessageToActiveChatRooms', event);
      }

      // if (
      //   (!this.opActiveChatRoom?.id && !urlParams.get('chat_room_id')) ||
      //   (urlParams.get('chat_room_id') &&
      //     this.opActiveChatRoom?.id !== +urlParams.get('chat_room_id'))
      // ) {
      //   this.$store.dispatch('opSetChatNotification', event);
      // }
    },

    //chat transfers
    setChatRoomTransfers(data) {
      const transfers = data?.data?.transfers

      //set transfers in state
      this.$store.dispatch('setChatRoomTransfers', transfers)

      if(Object.keys(transfers).length) {
        for(let i in transfers) {
          if(Number(i) === this.opUserInfo.id)
            this.sendTransferChat({
              data: transfers[i],
              transfers: transfers,
              withoutTimer: true,
            })
        }
      }
    },

    async sendTransferChat(data) {
      await this.$store.dispatch('setChatRoomTransfers', data.transfers)

      if(data.data.user_id_receive === this.opUserInfo.id) {
        await this.$store.dispatch('opSetTransferChatUserModalOpen', {
          open: true,
          data: data.data,
          withoutTimer: data?.withoutTimer || null
        })

        await this.playNotification(this.$t('modules.op.transfer_modal.title'), data?.system_message, 'send_transfer_chat')
      }
    },

    transferCanceled(data) {
      //set transfers in state
      this.$store.dispatch('setChatRoomTransfers', data.transfers)

      if(data.data.user_id_sender === this.opUserInfo.id) {
        this.$store.dispatch('opSetTransferChatUserModalOpen', {
          open: false,
          data: null
        })
        // this.$store.dispatch('opSetTransferDisabled', false);
        // this.$toast(this.$t('modules.op.transfer_modal.operator_cancel_transfer'));
        this.$store.dispatch('updateAjaxDialog', [
          true,
          false,
          '',
          this.$t('modules.op.transfer_modal.operator_cancel_transfer'),
        ]);
      }

      if(data.data.user_id_receive === this.opUserInfo.id) {
        this.$store.dispatch('opSetTransferChatUserModalOpen', {
          open: false,
          data: null
        })

        // this.$toast(this.$t('modules.op.transfer_modal.transfer_is_canceled'));
        this.$store.dispatch('updateAjaxDialog', [
          true,
          false,
          '',
          this.$t('modules.op.transfer_modal.transfer_is_canceled'),
        ]);
      }
    },
    transferAccepted(data) {
      //set transfers in state
      this.$store.dispatch('setChatRoomTransfers', data.transfers)

      if(data.data.user_id_sender === this.opUserInfo.id) {
        // this.$store.dispatch('opSetTransferDisabled', false);
        // this.$toast(this.$t('modules.op.transfer_modal.operator_accept_dialog'));
        this.$store.dispatch('updateAjaxDialog', [
          true,
          false,
          '',
          this.$t('modules.op.transfer_modal.operator_accept_dialog'),
          false,
          {},
          'link',
          {chat_room_id: data.data.chat_room_id},
        ]);

        //exit from dialog if it activated
        if (this.opActiveChatRoomFromState === data.data.chat_room_id) {
          
          this.$store.dispatch('opClearActiveChat');

          this.$store.dispatch('updateAjaxDialog', [
            true,
            false,
            '',
            this.$t('modules.op.texts.chat_exited'),
          ]);
        }
      }
    },

    transferCancelledByTimeout(data) {
      this.$store.dispatch('setChatRoomTransfers', data.transfers)

      if(data.data.user_id_receive === this.opUserInfo.id) {
        this.$store.dispatch('opSetTransferChatUserModalOpen', {
          open: false,
          data: null
        })
        this.$nextTick(() => {
          // this.$toast(this.$t('modules.op.transfer_modal.transfer_is_canceled'));
          this.$store.dispatch('updateAjaxDialog', [
            true,
            false,
            '',
            this.$t('modules.op.transfer_modal.transfer_is_canceled'),
          ]);
        })
      }

      if(data.data.user_id_sender === this.opUserInfo.id) {
        // this.$toast(this.$t('modules.op.transfer_modal.transfer_is_canceled'));
        this.$store.dispatch('updateAjaxDialog', [
          true,
          false,
          '',
          this.$t('modules.op.transfer_modal.transfer_is_canceled'),
        ]);
      }
    },

    async rulesPlayNotification(data, eventName = null) {
      const chatRoom = data?.data

      //Check if dialog not available for me
      if (chatRoom?.subject_id) {
        const even = ({id}) => id === chatRoom.subject_id;
        if ( !this.opSubjectList?.some(even) ) return
      }
      //end Check if dialog not available for me

      await this.$store.dispatch('opSetChatNotification', 'update');

      if (chatRoom?.status === 'new' && !chatRoom?.from_operator) {
        await this.playNotification(this.$t('modules.op.texts.new_dialog'), null, eventName)
        if(this.opUserInfo?.active_status?.can_receive) {
          // this.$toast(this.$t('modules.op.texts.new_dialog'))
          await this.$store.dispatch('updateAjaxDialog', [
            true,
            false,
            '',
            this.$t('modules.op.texts.new_dialog'),
            false,
            {},
            'link',
            {chat_room_id: chatRoom.id},
          ]);
        }
      } else if(
        chatRoom?.status === 'processed' &&
        chatRoom?.extra_data?.auto_connected === this.opUserInfo?.id
      ) {
        await this.playNotification(null, null, eventName);
      }
    },

    async playNotification(title = null, text = null, eventName = null) {
      //notifications only for online status
      if(!this.opUserInfo?.active_status?.can_receive) return
      const settings_json =  this.opUserInfo?.settings_json

      //play Notification if NOT Disabled settings
      if (!settings_json?.notifications_browser_disabled || settings_json?.notifications_browser_disabled !== true ) {
        await HELPERS.showBrowserNotification({
          title: title || this.$t('modules.op.texts.new_message'),
          body: text || '',
        });
      }

      //play Sound if Enabled settings
      if (settings_json?.notifications_sound_enabled) {

        try {
          const audioSound = new Audio(this._returnAudioSrcByUserSettings(eventName, settings_json));
          await audioSound.load()
          await audioSound.play()
            .then(() => this.$consoleLogHandler('Audio started playing successfully!'))
            .catch(err => this.$consoleLogHandler({text:'Error playing audio:', data: err }));
        } catch(e) {
          console.log('catch Error on new Audio', e)
        }
      }
    }, 

    _returnAudioSrcByUserSettings(eventName = null, settings_json) {
      let soundUrl = '/sound_5.mp3'
      if (settings_json?.selectedSound && eventName) {
        soundUrl = settings_json.selectedSound?.[eventName]?.sound || soundUrl
      } 
      
      return soundUrl;
    },

    reloadPageIfUserOnBotSettings() {
      if (this.$route?.name === 'bot_settings') {
        setTimeout(() => {
          location.reload();
        }, 5000)
      }
    },

    async statusChange(data) {
      if(data?.user_id === this.user?.user?.id) {
        await this.$store.dispatch('setUserInfoKey', {
          key: 'status_id',
          value: data.status_id,
        });
      }
    },
    //copilot
    async pushMessageFromCopilot(event) {
      console.log(event, 'pushMessageFromCopilot')

      if (this.opActiveChatRoom?.id === event.data.chat_room_id) {
        await this.$store.dispatch('opAddMessageToActiveChatRooms', event);
      }
    },


    //INIT KW WIDGET
    async initCodeChatWidget() {
      const bot_id = this.get_instance_settings.find((s) => s.key === 'operator_widget_bot').value
      const widget_url = this.get_instance_settings.find((s) => s.key === 'operator_widget_url').value

      let kw_init_params = {
        language_code: "uk",
        bot_id: bot_id || '1',
        launcher: {
          type: "image",
          staticImg: {
            src: 'https://storage.static.kwizbot.io/kwdev.kwizbot.io/static/CopilotLogo.png',
            fit: "unset",
          },
        },
        titleImageUrl: 'https://storage.static.kwizbot.io/kwdev.kwizbot.io/static/CopilotLogo.png',
        botAvatarImageUrl: 'https://storage.static.kwizbot.io/kwdev.kwizbot.io/static/CopilotLogo.png',
        title: "AI Helper",
        subtitle:"AI помічник оператора",
        btn_restart_enabled: true,
        params_from_site: {},
      }

      await (function (k, w, i, z, b, o, t) {
        k["KwizbotWidget"] = b;
        (k[b] =
          k[b] ||
          function () {
            w.head.insertAdjacentHTML(
              "beforeend",
              '<style type="text/css"></style>'
            );
            (k[b].q = k[b].q || []).push(arguments);
          }),
          (k[b].l = 1 * new Date());
        (o = w.createElement(i)), (t = w.getElementsByTagName(i)[0]);
        o.async = 1;
        o.src = z;
        t.parentNode.insertBefore(o, t);
      })(
        window,
        document,
        "script",
        `${widget_url}kwjs.js`,
        "kw"
      );

      try {
        // eslint-disable-next-line
        await kw("init", kw_init_params);
      } catch (e) {
        console.log(e)
      }

    },
  },

  components: {
    AxiosPreloaderAndResponse,
    ModalTransferChatUser,
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-application--wrap {
  overflow: hidden;
  max-width: 100vw;
  
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    min-height: fit-content;
    overflow: hidden;
    max-width: 100vw;
  }
}
</style>

<style lang="scss">

html, body {
  overflow-x: hidden;
  max-width: 100vw;
  box-sizing: border-box;
}

@media screen and (max-width: 1299px) {
  html, body {
    overflow: hidden !important;
    max-width: 100vw !important;
  }
  
  .v-application {
    overflow: hidden !important;
    max-width: 100vw !important;
  }
}
</style>
